import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {MdDeleteForever, MdEdit, MdImage} from "react-icons/md";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {WiDirectionDown, WiDirectionUp} from "react-icons/wi";
import {AiOutlineSearch} from "react-icons/ai";
import {FaArrowDown, FaArrowUp, FaPercentage, FaWallet} from "react-icons/fa";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';

import {currencyFormat} from "../../utils/masks";
import {loadList} from "../../services/Trading";
import CustomButton from "../../components/Form/Button";
import {useDispatch, useSelector} from "react-redux";
import {IconButton} from "@material-ui/core";
import AlertDelete from "../../components/Alert/AlertDelete";
import {actions} from "../../redux/actions";
import {getBank} from "../../services/Bank";
import messageTypes from "../../constants/MessagesTypes";
import {Form} from "@unform/web";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../utils/date";
import swal from "@sweetalert/with-react";
import InputDate from "../../components/Form/InputDate";
import InputMask from "../../components/Form/InputMask";
import Divider from "@mui/material/Divider";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    TradingListPageHeader,
    TradingBelowHeaderSection,
    HeaderActions,
    CurrencyPairButton,
    NewTradingButton,
    TradingCard,
    MetaDashboard,
    PeriodSummarySection,
    PeriodSummaryHeading,
    PeriodSummaryGrid,
    PeriodSummaryCard,
    PeriodSummaryIconWrap,
    PeriodSummaryLabel,
    PeriodSummaryValue,
    PeriodSummaryExtras,
    MetaProgressBlock,
    MetaProgressLabel,
    MetaProgressTrack,
    MetaProgressFill,
    MetaPayoutFieldWrap,
    MetaSuggestionsList,
    MetaMuted,
    FilterSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterRow,
    FilterField,
    FilterButtonWrap,
    ActionButtons,
    ResultBadge,
} from "./styles";
import {FormWrapper} from "../../styles/listPageTheme";
import {
    StrategyEmptyState,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
} from "../Strategy/styles";

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    textTransform: 'none',
};

export default function Trading() {
    const [loading, setLoading] = useState(false);
    const [deleteTrading, setDeleteTrading] = useState(null);
    const [total, setTotal] = useState(0);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const {coinType, profitObtainedToday, meta, amount, hideAmount} = useSelector((state) => state.BankReducer);
    const dispatch = useDispatch();
    const [payout, setPayout] = useState(100);
    const { t } = useTranslation();

    const formRef = useRef(null);

    const [filter, setFilter] = useState([
        {
            startDate: dateFirstDayCurrent(),
            endDate: dateCurrent(),
        }
    ]);

    useEffect(() => {
        setLoading(true);

        loadList({
            page: page,
            per_page: 25,
            typeWinOrLoss: 'WIN',
            startDate: filter[0].startDate,
            endDate: filter[0].endDate,
        }).then((data) => {
            if (!data || data === '') {
                return;
            }

            setTotal(data.data.total);
            setList(data.data);
            setLoading(false);
        });

        return function cleanup() {
            setList([]);
        };
    }, [page, deleteTrading === true, filter]);

    useEffect(() => {
        getBank().then((data) => {
            dispatch(actions.updateBank(data));
        });
    }, [deleteTrading === true]);

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter(
                [{
                    startDate: data.startDate,
                    endDate: data.endDate,
                }]
            );

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    function showImage(urlImage, currencyPair) {
        swal(
            {
                showCloseButton: true,
                className: 'trading-modal',
                confirmButtonText: 'Fechar',
                content: <div>
                    <h3 className={"font-weight-bolder"}>{currencyPair}</h3>
                    <br/>
                    <div className={"img-trading-modal"}>
                        <img src={urlImage} alt={'Imagem da negociação'}/>
                    </div>
                </div>,
            }
        );
    }

    const dailyGoal = meta ? parseFloat(meta.stopWin) : 0;
    const profitTodayRaw = profitObtainedToday != null ? parseFloat(profitObtainedToday) : 0;
    const goalProgressPct =
        dailyGoal > 0
            ? Math.min(100, Math.max(0, (profitTodayRaw / dailyGoal) * 100))
            : 0;

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                <TradingListPageHeader>
                    <h1>
                        <i className="fa fa-folder-open" aria-hidden="true"/> {t('trading_card_title')} <span className="badge">{total}</span>
                    </h1>
                    <HeaderActions>
                        <CurrencyPairButton as={Link} to="/currency-pair">
                            <i className="fas fa-list"/> {t('currency_pair_list_title')}
                        </CurrencyPairButton>
                        <CurrencyPairButton as={Link} to="/trading/import" className="import-csv">
                            <i className="fas fa-file-import" aria-hidden="true"/> {t('strategy_btn_import_CSV')}
                        </CurrencyPairButton>
                        <NewTradingButton as={Link} to="/trading/new">
                            <i className="fas fa-plus"/> {t('add')}
                        </NewTradingButton>
                    </HeaderActions>
                </TradingListPageHeader>

                <TradingBelowHeaderSection>
                {meta && (
                    <MetaDashboard>
                        <PeriodSummarySection>
                            <PeriodSummaryHeading>
                                <i className="fas fa-chart-pie" aria-hidden="true"/> {t('moviment_summary_title')}
                            </PeriodSummaryHeading>
                            <PeriodSummaryGrid>
                                {profitObtainedToday < parseFloat(meta.stopWin) && (
                                    <PeriodSummaryCard
                                        $border="rgba(0, 212, 255, 0.28)"
                                        $borderHover="rgba(0, 212, 255, 0.52)"
                                        $line="#00d4ff"
                                        $glow="rgba(0, 212, 255, 0.18)"
                                    >
                                        <PeriodSummaryIconWrap
                                            $bg="rgba(0, 212, 255, 0.14)"
                                            $fg="#5ce1ff"
                                            $shadow="rgba(0, 212, 255, 0.22)"
                                        >
                                            <FaPercentage aria-hidden="true"/>
                                        </PeriodSummaryIconWrap>
                                        <PeriodSummaryLabel>{t('trading_stat_label_payout')}</PeriodSummaryLabel>
                                        <PeriodSummaryValue $c="#7ae8ff">
                                            {(payout != null ? payout : 100).toFixed(2)}%
                                        </PeriodSummaryValue>
                                        <PeriodSummaryExtras style={{ textAlign: 'center' }}>
                                            <div style={{ fontSize: 12, fontWeight: 700, color: '#f29205', marginBottom: 10 }}>
                                                {t('trading_goal_suggestions')}
                                            </div>
                                            <FormWrapper>
                                                <Form onSubmit={() => {}}>
                                                    <MetaPayoutFieldWrap>
                                                        <InputMask
                                                            size="small"
                                                            type="text"
                                                            name="payout"
                                                            id="payout"
                                                            label="Payout"
                                                            mask={'percent'}
                                                            defaultValue={(payout ? payout : 100).toFixed(2)}
                                                            InputProps={{
                                                                endAdornment: <><Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                                                    <IconButton aria-label="directions" onClick={() => {
                                                                        setPayout(parseFloat(document.getElementById('payout').value))
                                                                    }}>
                                                                        <i className="fa fa-check text-xs" aria-hidden="true"></i>
                                                                    </IconButton></>,
                                                            }}
                                                        />
                                                    </MetaPayoutFieldWrap>
                                                </Form>
                                            </FormWrapper>
                                            <MetaSuggestionsList>
                                                {Array.from({ length: 5 }, (_, index) => (
                                                    <MetaMuted as="div" key={index}>
                                                        {payout && <>
                                                            {t('trading_goal_inputs', {
                                                                'qtdeInput': index + 1,
                                                                'value': `${coinType} ${currencyFormat(parseFloat(profitObtainedToday ? Math.abs(parseFloat(profitObtainedToday) - parseFloat(meta.stopWin)) :  parseFloat(meta.stopWin)) / ((index + 1) * (payout/100)))}`
                                                            })}
                                                        </>}
                                                    </MetaMuted>
                                                ))}
                                            </MetaSuggestionsList>
                                        </PeriodSummaryExtras>
                                    </PeriodSummaryCard>
                                )}
                                <PeriodSummaryCard
                                    $border="rgba(91, 211, 124, 0.35)"
                                    $borderHover="rgba(91, 211, 124, 0.58)"
                                    $line="#5bd37c"
                                    $glow="rgba(91, 211, 124, 0.2)"
                                >
                                    <PeriodSummaryIconWrap
                                        $bg="rgba(91, 211, 124, 0.14)"
                                        $fg="#7ee8a0"
                                        $shadow="rgba(91, 211, 124, 0.22)"
                                    >
                                        <FaArrowUp aria-hidden="true"/>
                                    </PeriodSummaryIconWrap>
                                    <PeriodSummaryLabel>{t('trading_stat_label_remaining')}</PeriodSummaryLabel>
                                    <PeriodSummaryValue $c="#8aedab">
                                        {coinType} {currencyFormat(parseFloat(profitObtainedToday ? Math.abs(parseFloat(profitObtainedToday) - parseFloat(meta.stopWin)) :  parseFloat(meta.stopWin)))}
                                    </PeriodSummaryValue>
                                    <PeriodSummaryExtras>
                                        <MetaProgressBlock>
                                            <MetaProgressLabel>
                                                <span>{t('trading_meta_goal_progress')}</span>
                                                <span>{Math.round(goalProgressPct)}%</span>
                                            </MetaProgressLabel>
                                            <MetaProgressTrack>
                                                <MetaProgressFill $pct={goalProgressPct}/>
                                            </MetaProgressTrack>
                                        </MetaProgressBlock>
                                        <MetaMuted>
                                            {t('trading_goal_day')} {coinType} {currencyFormat(parseFloat(meta ? meta.stopWin : 0))}<br/>
                                            {t('trading_goal_day_profit_prejudice')} {coinType} {currencyFormat(parseFloat(profitObtainedToday ? profitObtainedToday : 0))}
                                        </MetaMuted>
                                    </PeriodSummaryExtras>
                                </PeriodSummaryCard>
                                {!hideAmount && (
                                    <PeriodSummaryCard
                                        $border={amount < 0 ? 'rgba(255, 107, 107, 0.35)' : 'rgba(91, 211, 124, 0.35)'}
                                        $borderHover={amount < 0 ? 'rgba(255, 107, 107, 0.6)' : 'rgba(91, 211, 124, 0.58)'}
                                        $line={amount < 0 ? '#ff6b6b' : '#5bd37c'}
                                        $glow={amount < 0 ? 'rgba(255, 107, 107, 0.2)' : 'rgba(91, 211, 124, 0.2)'}
                                    >
                                        <PeriodSummaryIconWrap
                                            $bg={amount < 0 ? 'rgba(255, 107, 107, 0.14)' : 'rgba(91, 211, 124, 0.14)'}
                                            $fg={amount < 0 ? '#ff8a8a' : '#7ee8a0'}
                                            $shadow={amount < 0 ? 'rgba(255, 107, 107, 0.22)' : 'rgba(91, 211, 124, 0.22)'}
                                        >
                                            {amount < 0 ? <FaArrowDown aria-hidden="true"/> : <FaWallet aria-hidden="true"/>}
                                        </PeriodSummaryIconWrap>
                                        <PeriodSummaryLabel>{t('trading_stat_label_bank')}</PeriodSummaryLabel>
                                        <PeriodSummaryValue $c={amount < 0 ? '#ff9a9a' : '#8aedab'}>
                                            {coinType} {currencyFormat(amount)}
                                        </PeriodSummaryValue>
                                        <PeriodSummaryExtras>
                                            <MetaMuted style={{ fontSize: 12, fontStyle: 'italic' }}>
                                                {t('trading_meta_bank_footnote')}
                                            </MetaMuted>
                                        </PeriodSummaryExtras>
                                    </PeriodSummaryCard>
                                )}
                            </PeriodSummaryGrid>
                        </PeriodSummarySection>
                    </MetaDashboard>
                )}

                <TradingCard>
                    <FilterSection>
                        <StyledFilterFormWrapper>
                            <Form ref={formRef} onSubmit={handleSubmit}>
                                <FilterTitle>
                                    <i className="fas fa-funnel-dollar"/> {t('filter')}
                                </FilterTitle>
                                <FilterRow>
                                    <FilterField>
                                        <InputDate
                                            name="startDate"
                                            label={t('filter_start_date')}
                                            value={firstDayMonth()}
                                            size={"small"}
                                        />
                                    </FilterField>
                                    <FilterField>
                                        <InputDate
                                            name="endDate"
                                            label={t('filter_end_date')}
                                            value={new Date()}
                                            size={"small"}
                                        />
                                    </FilterField>
                                    <FilterButtonWrap>
                                        <CustomButton
                                            className="btn font-weight-bold text-capitalize mobile-button"
                                            type="submit"
                                            startIcon={<AiOutlineSearch/>}
                                            style={filterSearchBtnStyle}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                            }}
                                        >
                                            {t('filter_btn_submmit')}
                                        </CustomButton>
                                    </FilterButtonWrap>
                                </FilterRow>
                            </Form>
                        </StyledFilterFormWrapper>
                    </FilterSection>

                    <StrategyTableWrapper>
                        {loading ? (
                            <StrategyLoadingButton
                                className="btn btn-primary text-capitalize font-weight-bold"
                                loading={loading}
                                type="button"
                            >
                                {t('loading')}
                            </StrategyLoadingButton>
                        ) : (
                            <>
                                {list && list.data && list.data.length ? (
                                    <>
                                    <StrategyTableContainer>
                                        <Table aria-label={t('trading_card_title')}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" />
                                                    <TableCell align="center">{t('trading_table_col_date')}</TableCell>
                                                    <TableCell align="center">{t('trading_table_col_currency_pair')}</TableCell>
                                                    <TableCell align="center">{t('trading_table_col_strategy')}</TableCell>
                                                    <TableCell align="center">{t('trading_table_col_value_invested')}</TableCell>
                                                    <TableCell align="center">{t('trading_table_col_profit_prejudice')}</TableCell>
                                                    <TableCell align="center">{t('trading_table_col_options')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {list.data.map((row) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell align="center">
                                                            {row.profitObtained > 0 && (
                                                                <ResultBadge style={{
                                                                    background: 'rgba(46, 204, 113, 0.2)',
                                                                    color: '#5bd37c',
                                                                    border: '1px solid rgba(46, 204, 113, 0.45)',
                                                                }}>Win</ResultBadge>
                                                            )}
                                                            {!row.profitObtained && (
                                                                <ResultBadge style={{
                                                                    background: 'rgba(255,255,255,0.08)',
                                                                    color: '#e0e0e0',
                                                                    border: '1px solid rgba(255,255,255,0.15)',
                                                                }}>{t('draw')}</ResultBadge>
                                                            )}
                                                            {row.profitObtained < 0 && (
                                                                <ResultBadge style={{
                                                                    background: 'rgba(255, 107, 107, 0.2)',
                                                                    color: '#ff8a8a',
                                                                    border: '1px solid rgba(255, 107, 107, 0.45)',
                                                                }}>Loss</ResultBadge>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center" component="th" scope="row">
                                                            {new Date(row.created.date).toLocaleDateString()}
                                                            <br/>
                                                            <small style={{ color: '#888' }}>{row.observation ? `${t('trading_table_observation')}: ${row.observation}` : ''}</small>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.currencyPair} {row.direction && row.direction === 'COMPRA' && <WiDirectionUp size={25}/>}
                                                            {row.direction && row.direction === 'VENDA' && <WiDirectionDown size={38}/>}
                                                        </TableCell>
                                                        <TableCell align="center">{row.strategy ? row.strategy.name : t('text_not_info')}</TableCell>
                                                        <TableCell align="center">{coinType} {currencyFormat(row.investmentValue)}</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: 700 }}>
                                                            {row.profitObtained > 0 && <span style={{ color: '#5bd37c' }}>{coinType} {currencyFormat(row.profitObtained)}</span>}
                                                            {!row.profitObtained && <span>{coinType} {currencyFormat(row.profitObtained)}</span>}
                                                            {row.profitObtained < 0 && <span style={{ color: '#ff8a8a' }}>{coinType} {currencyFormat(row.profitObtained)}</span>}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <ActionButtons>
                                                                <Link to={`/trading/${row.id}/edit`}>
                                                                    <IconButton aria-label="edit">
                                                                        <MdEdit/>
                                                                    </IconButton>
                                                                </Link>
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    onClick={() => { setDeleteTrading(row.id); }}
                                                                >
                                                                    <MdDeleteForever/>
                                                                </IconButton>
                                                                {row.image && (
                                                                    <IconButton
                                                                        aria-label="view-image"
                                                                        onClick={() => {
                                                                            showImage(`${process.env.REACT_APP_API_ENDPOINT}/${row.image}`, row.currencyPair);
                                                                        }}
                                                                    >
                                                                        <MdImage/>
                                                                    </IconButton>
                                                                )}
                                                            </ActionButtons>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TableCell colSpan={7}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            flexWrap: 'wrap',
                                                            gap: 12,
                                                        }}>
                                                            <StrategyPaginationInfo>
                                                                {t('table_pagination_text', {
                                                                    page,
                                                                    totalPage: list.total_page + 1,
                                                                })}
                                                            </StrategyPaginationInfo>
                                                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                <StrategyPaginationButton
                                                                    type="button"
                                                                    onClick={() => setPage(page - 1)}
                                                                    disabled={page <= 1}
                                                                >
                                                                    <IoIosArrowBack/> {t('table_pagination_back')}
                                                                </StrategyPaginationButton>
                                                                <StrategyPaginationButton
                                                                    type="button"
                                                                    onClick={() => setPage(page + 1)}
                                                                    disabled={!list.next_page}
                                                                >
                                                                    {t('table_pagination_next')} <IoIosArrowForward/>
                                                                </StrategyPaginationButton>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </StrategyTableContainer>
                                        {deleteTrading && typeof deleteTrading === 'string' && (
                                            <AlertDelete
                                                setSuccessDelete={setDeleteTrading}
                                                urlDelete={`${process.env.REACT_APP_API_ENDPOINT}/api/trading/delete/${deleteTrading}`}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <StrategyEmptyState>
                                        <i className="fa fa-chart-line" aria-hidden="true"/>
                                        <p>{t('trading_empty_title')}</p>
                                        <span>{t('trading_empty_subtitle')}</span>
                                    </StrategyEmptyState>
                                )}
                            </>
                        )}
                    </StrategyTableWrapper>
                </TradingCard>
                </TradingBelowHeaderSection>
            </ContentArea>
        </TradingWrapper>
    );
}
